import DataChartIconPath from "@ingka/ssr-icon/paths/data-chart";

export default DataChartIconPath;
